import projection from '../generated/chain29_voucher.json';
import { AcceptanceManifest } from '../types';

export const chain29VoucherAcceptanceManifest = projection as AcceptanceManifest;
